<template>
    <div>
        <div class="search_item mb19">
            <div class="search_input detection_search_input">
                <el-input :placeholder="$t('st')" v-model="searchInput" @keypress.native.enter="setFilterFunc('su',searchInput)"></el-input>
                <button class="search_btn mypage_search_btn" @click="setFilterFunc('su',searchInput)"></button>
            </div>
            <button class="search_filter_btn" @click="openFilter('qna-filter-modal')"></button>
        </div>
        <qna-filter-modal></qna-filter-modal>
<!--        <div class="search_item mb19">
            <div class="filter_category_box mr5">
                <el-select id="category" class="my_filter select"
                           popper-class="select_style" v-model="tab" :popper-append-to-body="false"
                           @change="setFilterFunc('isa', tab)">
                    <el-option :value="''" :label="$t('all')"></el-option>
                    <el-option :value="0" :label="$t('answer_wait')"></el-option>
                    <el-option :value="1" :label="$t('answer_finish')"></el-option>
                </el-select>
            </div>
            <div class="search_input">
                <el-input :placeholder="$t('st')" v-model="searchInput"
                          @keypress.enter.native="setFilterFunc('su',searchInput)">
                </el-input>
                <button class="search_btn" @click="setFilterFunc('su', searchInput)"></button>
            </div>
        </div>-->
    </div>
</template>

<script>
import QnaFilterModal from "@/components/filter/QnaFilterModal";
import boardFilterUtil from "@/components/board/boardFilterUtil";

const {filterConfig} = boardFilterUtil

export default {
    name: "BoardFilterQnaLayout",
    mixins: [],
    components: {
        boardFilterUtil,
        QnaFilterModal
    },
    inject: ['setFilter'],
    provide() {
        return{

        }
    },
    props: {
        filterData: {
            default: () => {
                return {}
            }
        },
        paginationData: {
            type: Object,
            default: {
                total: 0,
                page: 0,
                size: 0,
            }
        },
    },
    data() {
        return{
            searchInput: '',
            tab: '',
        }
    },
    beforeRouterEnter() {},
    created() {
        this.setterFilterDataInData();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
        openFilter(name) {
            this.$modal.show(name, {filterData: this.filterData});
        },
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    // this[classname] =
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
        },
        setFilterFunc(key, value){
            this.setFilter(key, value)
        }
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
